import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { getHomePremium, homePremiumResumeCardSx } from "../styles/homePremiumStyles";

/** Resume banner for the home dashboard (light + dark). */
export default function ResumeLastGameCard({
    onResume,
    disabled,
    loading,
    storyTitle,
    statusText,
    resumeHint,
}) {
    const { t } = usePagesTranslation();
    const { isDark } = useSlidingAppearance();
    const home = getHomePremium(isDark);

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                mb: 0,
                p: 1.5,
                borderRadius: "14px",
                textAlign: "left",
                position: "relative",
                zIndex: 1,
                ...homePremiumResumeCardSx(isDark),
            }}
        >
            <Button
                type="button"
                fullWidth
                onClick={onResume}
                disabled={disabled}
                startIcon={
                    loading ? (
                        <CircularProgress size={20} sx={{ color: home.teal }} />
                    ) : (
                        <PlayArrowRoundedIcon sx={{ fontSize: 22, color: home.teal }} />
                    )
                }
                sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "1rem",
                    color: home.text,
                    py: 0.75,
                    px: 0.5,
                    minHeight: 44,
                    minWidth: 0,
                    maxWidth: "100%",
                    borderRadius: "12px",
                    mb: 0.35,
                    fontFamily:
                        '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif',
                    "& .MuiButton-startIcon": {
                        mr: 1,
                        flexShrink: 0,
                    },
                    "&:hover": {
                        bgcolor: home.tealSoft,
                    },
                    "&.Mui-disabled": {
                        color: home.text,
                        opacity: 1,
                    },
                }}
            >
                {t("native.home.resumeLastGame", { defaultValue: "Resume Last Game" })}
            </Button>
            {storyTitle ? (
                <Typography
                    sx={{
                        fontSize: "0.9375rem",
                        lineHeight: 1.4,
                        fontWeight: 600,
                        color: home.text,
                        px: 0.5,
                        fontFamily:
                            '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif',
                    }}
                >
                    {storyTitle}
                </Typography>
            ) : null}
            {statusText ? (
                <Typography
                    sx={{
                        fontSize: "0.8125rem",
                        lineHeight: 1.45,
                        fontWeight: 500,
                        color: home.textMuted,
                        mt: storyTitle ? 0.25 : 0,
                        px: 0.5,
                        fontFamily:
                            '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif',
                    }}
                >
                    {statusText}
                </Typography>
            ) : null}
            {resumeHint ? (
                <Typography
                    sx={{
                        fontSize: "0.75rem",
                        lineHeight: 1.4,
                        color: home.textSubtle,
                        mt: 0.5,
                        px: 0.5,
                        fontFamily:
                            '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif',
                    }}
                >
                    {resumeHint}
                </Typography>
            ) : null}
        </Box>
    );
}
